import { AxiosError } from "axios";

export function getErrorMessage(error: unknown, fallback: string): string {
  const apiError = error as AxiosError<{ message?: string; error?: string }>;
  const apiMessage =
    apiError?.response?.data?.message || apiError?.response?.data?.error;
  return apiMessage || fallback;
}
